import { PromoNewApiPaths, PromoNewComponents, PromoNewOperations } from '@affiliate-cabinet/types'

import { resolveDomain, RestClient } from '../../../utils'

export const getApiV3PromoBannersIdLandings = async (data: PromoNewOperations['GetApiV3PromoBannersIdLandings']['parameters']['path']) => {
  const client = new RestClient(PromoNewApiPaths.GetApiV3PromoBannersIdLandings.replace(':id', data.id.toString()), {}, resolveDomain(), {
    mode: 'cors',
    referrerPolicy: 'no-referrer',
  })

  return client.get<PromoNewComponents['schemas']['LandingsCollection']>('')
}
